<template>
  <div class="center">
    <div class="loader">
      <svg version="1.1"
           xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink"
           x="0px"
           y="0px"
           width="40px"
           height="40px"
           viewBox="0 0 50 50"
           style="enable-background:new 0 0 50 50;"
           xml:space="preserve">
        <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
        </path>
      </svg>
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {
      }
    }
  }
</script>


<style scoped>
  .loader {
    margin: 0 0 2em;
    height: auto;
    width: 100px;
    text-align: center;
    padding: 1em;
    margin: 0 auto;
    vertical-align: top;
    padding-top: 100px;
  }

  svg path {
    fill: #fb557a;
  }

  .loader>svg {
    animation: spin .3s linear infinite;
    transform-origin: 50% 50%;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// client/views/Loader.vue